export default __webpack_public_path__ + "static/media/home_cookies_first_big.c2826baf.png";